import React, { useState } from 'react';
import NewEventOptionsPopper from './NewEventOptionsPopper';
import '@aurodesignsystem/auro-button';
import { useHistory } from "react-router-dom";
import './NewEventButton.scss';
import { AuthorizationAccessCheckAllEvents, useAuthorization, IsAuthorizedOnOneEvent} from "meportal/AuthorizationProvider";
import * as PermissionSetConstants from "../../../constants/PermissionSet";

interface NewEventButtonProps {
  onEventCreate: (eventType: string) => void;
  contextPath: string;
}

function NewEventButton({ onEventCreate, contextPath }: NewEventButtonProps) {
  const [activeStateClicked, setActiveStateClicked] = useState({ value: false, text: 'default' });
  const history = useHistory();
  const { eventPermissions, userClaims } = useAuthorization();
  const isFleetTypeAuthorized = IsAuthorizedOnOneEvent(PermissionSetConstants.CreateButtonFleetType, eventPermissions, userClaims);

  const handleEventCreate = (eventType: string) => {
    if (eventType === 'OTSFleet') {
        history.push(contextPath + "/create-new-fleet-type-event");
    }
    setActiveStateClicked({ value: true, text: eventType });
  };

  const handleCreateButtonClick = () => {
    history.push( contextPath + "/create-ots");
  };

  const triggerContent = () => (
      <button className='options-button'>
        <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path fillRule="evenodd" clipRule="evenodd" d="M6.39705 9.55379L6.46967 9.46967C6.73594 9.2034 7.1526 9.1792 7.44621 9.39705L7.53033 9.46967L12 13.939L16.4697 9.46967C16.7359 9.2034 17.1526 9.1792 17.4462 9.39705L17.5303 9.46967C17.7966 9.73594 17.8208 10.1526 17.6029 10.4462L17.5303 10.5303L13.061 15L12.7071 15.3539C12.3166 15.7444 11.6834 15.7444 11.2929 15.3539L10.939 15L6.46967 10.5303C6.2034 10.2641 6.1792 9.8474 6.39705 9.55379L6.46967 9.46967L6.39705 9.55379Z" fill="white"/>
</svg>
        </span>
      </button>
  );

  const popperContent = () => (
    <div className="event-options-container">
      <button className="event-option" onClick={() => handleEventCreate('OTSFleet')}>
        Create event by fleet
      </button>
    </div>
  );

  return (
    <div className={isFleetTypeAuthorized ? "new-event-button" : ""}>
          <auro-button
        class= {isFleetTypeAuthorized ? "auro-new-event-button" : ""}
        variant="primary"
        fluid
        onClick={handleCreateButtonClick}
        data-testid="plus-btn">
        <span className="btnlabel-white edit-button"><svg className="plus-sign" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M11.8982 7.00685L12 7C12.3797 7 12.6935 7.28215 12.7432 7.64823L12.75 7.75V11.25H16.25C16.6297 11.25 16.9435 11.5322 16.9932 11.8982L17 12C17 12.3797 16.7178 12.6935 16.3518 12.7432L16.25 12.75H12.749L12.75 16.25C12.75 16.6297 12.4678 16.9435 12.1018 16.9932L12 17C11.6203 17 11.3065 16.7178 11.2568 16.3518L11.25 16.25L11.249 12.75H7.75C7.3703 12.75 7.05651 12.4678 7.00685 12.1018L7 12C7 11.6203 7.28215 11.3065 7.64823 11.2568L7.75 11.25H11.25V7.75C11.25 7.3703 11.5322 7.05651 11.8982 7.00685L12 7L11.8982 7.00685Z" fill="white"/>
    </svg> New event</span>
    </auro-button>
    <AuthorizationAccessCheckAllEvents permission={PermissionSetConstants.CreateButtonFleetType}>
      <div className="options-popper">
        <NewEventOptionsPopper
          popperContent={popperContent()}
          bottomContent={triggerContent()}
          filterSelected={activeStateClicked}
        />
      </div>
    </AuthorizationAccessCheckAllEvents>
    </div>
  );
}

export default NewEventButton;